import { render, staticRenderFns } from "./centerGoods.vue?vue&type=template&id=9b8dce1a&scoped=true&"
import script from "./centerGoods.vue?vue&type=script&lang=js&"
export * from "./centerGoods.vue?vue&type=script&lang=js&"
import style0 from "./centerGoods.vue?vue&type=style&index=0&id=9b8dce1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8dce1a",
  null
  
)

export default component.exports